<template>
  <div>
    <div class="slide-proportion-3-2">
      <div class="right-block-positioner">
        <div class="right-block__content">
          <circle-wrapper>
            <video-player-preview
              :poster-src="posterSrc"
              @click="playVideo"
            />
          </circle-wrapper>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import CircleWrapper from '../../slideComponents/CircleWrapper.vue';
  import VideoPlayerPreview from '../../slideComponents/VideoPlayer/VideoPlayerPreview.vue';
  import posterSrc from '../../../../assets/img/05.jpg';
  import videoSrc from '../../../../assets/video/191206_Okko_deisel_Morj_15s_new_legal.mp4';
  export default {
    components: {
      CircleWrapper,
      VideoPlayerPreview
    },
    data() {
      return {
        posterSrc,
        videoSrc
      };
    },
    methods: {
      playVideo() {
        this.$emit('play-video', videoSrc);
      }
    }
  };
</script>

<style lang="scss" scoped>
  @import '~styles/scss/slide-fragment.scss';
</style>



// WEBPACK FOOTER //
// src/components/SlideFragment/Slides/Fact5/Right.vue